import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.nameserver.delete;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_NAMESERVER_DELETE',
	method: 'POST',
	url: '/network/dns/domain/nameserver/delete.json',
});

export { actions, reducer, sagas, selectors };
